<template>
    <div class="">
        <b-button
            v-if="activeVersionVideoUrl"
            v-bind="finalButtonProps"
            @click="showVideoModal"
        >
            <b-icon v-if="buttonIcon" :icon="buttonIcon" :class="finalButtonProps.size === 'sm' ? 'mr-1' : 'mr-2'" variant="primary"></b-icon>
            {{ buttonText }}
        </b-button>
        <b-modal
            :id="uniqueId"
            v-if="activeVersionVideoUrl"
            v-model="modalShowing"
            v-bind="finalModalProps"
        >
            <div style="position: relative; padding-top: 56.25%;">
                <iframe
                    :src="activeVersionVideoUrl"
                    loading="lazy"
                    referrerpolicy="origin"
                    style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                    allowfullscreen="true"
                ></iframe>  <!-- need referrerpolicy="origin" at least, if you are restricting videos by origin -->
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'DocHubCloudflareVideoButton',
    components: {},
    mixins: [],
    props: {
        resource: {  // pass in the whole resource object, we need stuff from it like name, etc. - maybe also use for tracking
            type: Object,
            required: true,
        },
        buttonProps: {  // these get merged with defaults below
            type: Object,
            default: () => ({}),
        },
        modalProps: {  // these get merged with defaults below
            type: Object,
            default: () => ({}),
        },
        buttonIcon: {  // uses a default, but you can pass in a different icon or '' for no icon
            type: String,
            default: 'play-circle-fill',
        },
        buttonText: {  // uses a default, but you can pass in a different text
            type: String,
            default: 'Watch Video',
        },
    },
    data() {
        return {
            modalShowing: false,
        }
    },
    computed: {
        activeVersion() {
            return this.resource?.active_version || {};
        },
        activeVersionVideoUrl() {
            return this.activeVersion.cloudflare_video_url || '';
        },
        uniqueId() {
            return `videoModal-${this.activeVersion.id}`;
        },
        finalButtonProps() {
            const defaultButtonProps = {
                variant: 'sharp-primary',
                block: true,
                size: 'lg',
            };
            return {
                ...defaultButtonProps,
                ...this.buttonProps,
            };
        },
        finalModalProps() {
            const defaultModalProps = {
                title: this.resource.name,
                size: 'xxl',
                bodyClass: 'p-0',
                centered: true,
                hideFooter: true,
            };
            return {
                ...defaultModalProps,
                ...this.modalProps,
            };
        },
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        showVideoModal() {
            this.modalShowing = true;
        },
    },
}
</script>

<style lang="scss">
</style>